/* ============
 * Bill Module Mutations
 * ============
 */

import {
  FETCH_PAGINATED_BILLS,
  FETCH_BILL_STATUSES,
  FETCH_BILL_TYPES,
  RESET_BILLS,
  FETCH_CURRENT_BILL,
  BILL_QUERY,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_BILLS](state, { bills, pagination }) {
    state.items = bills;
    state.pagination = pagination;
  },

  [FETCH_BILL_STATUSES](state, statuses) {
    state.statuses = statuses;
  },

  [FETCH_BILL_TYPES](state, statuses) {
    state.types = statuses;
  },

  [RESET_BILLS](state) {
    state.all = [];
    state.items = [];
    state.pagination = {};
    state.currentBill = {};
  },

  [FETCH_CURRENT_BILL](state, bill) {
    state.currentBill = bill;
  },

  [BILL_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/bill/mutations.js